import gql from "graphql-tag";

export default gql`
  mutation AddFavourite($ID: ID! ) {
    addFavourite(ID: $ID)
  }
`;